import React, { useState } from 'react';

const FloatingSocial = () => {
  const [open, setOpen] = useState(false);

  const socials = [
    {
      href: 'https://wa.me/919999999999',
      icon: 'bi-whatsapp',
      className: 'floating-social-btn floating-btn-whatsapp',
      label: 'WhatsApp',
      ariaLabel: 'Contact on WhatsApp',
    },
    {
      href: 'https://www.facebook.com/chaitraleefoundation',
      icon: 'bi-facebook',
      className: 'floating-social-btn floating-btn-facebook',
      label: 'Facebook',
      ariaLabel: 'Follow on Facebook',
    },
    {
      href: 'https://www.instagram.com/chaitraleefoundation',
      icon: 'bi-instagram',
      className: 'floating-social-btn floating-btn-instagram',
      label: 'Instagram',
      ariaLabel: 'Follow on Instagram',
    },
  ];

  return (
    <div className="floating-social-container" role="complementary" aria-label="Social media links">
      {/* Expandable social links */}
      <div className={`floating-social-links${open ? ' open' : ''}`}>
        {socials.map(({ href, icon, className, label, ariaLabel }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
            data-label={label}
            aria-label={ariaLabel}
          >
            <i className={`bi ${icon}`}></i>
          </a>
        ))}
      </div>

      {/* Toggle button */}
      <button
        className="floating-toggle-btn"
        onClick={() => setOpen(prev => !prev)}
        aria-label={open ? 'Close social links' : 'Open social links'}
        aria-expanded={open}
      >
        <i className={`bi ${open ? 'bi-x-lg' : 'bi-share-fill'}`}></i>
      </button>
    </div>
  );
};

export default FloatingSocial;
